import { ArrowDownTrayIcon, ArrowUpTrayIcon, XMarkIcon } from '@heroicons/react/20/solid';
import { addMonths, format } from 'date-fns';
import React, { useEffect, useMemo, useState } from "react";
import { CSVLink } from 'react-csv';
import "react-datepicker/dist/react-datepicker.css";
import { connect } from 'react-redux';
import { Actions as EMPLOYEEACTIONS } from '../../../../store/actions/employeeActions';
import EarningsErrorsRow from "./EarningsErrorsRow";

const ImportEmployeeModal = ({
    modalStatus,
    closeModal,
    uploadResults,
    filesUploaded,
    getPreviousEarningsTemplate,
    uploadPreviousEarnings,
    uploadFile,
    uploading,
}) => {

    const [file, setFile] = useState(false);
    const [importAll, setImportAll] = useState(false);
    const [acknowledgement, setAcknowledgement] = useState(false);

    const importStage = useMemo(() => {
        if (uploadResults) return 'Review'
        if (file) return 'Import'
        if (!modalStatus) return 'Download'
    }, [modalStatus, file, uploadResults])

    const { errors, saved } = { ...uploadResults }

    useEffect(() => {
        if (importStage !== 'Import') {
            setFile(null)
            setAcknowledgement(false)
        }
    }, [importStage])

    const ModuleStage = () => {
        switch (importStage) {
            default:
            case 'Download': return (<>
                <div className='col-xs-12'>
                    <p>
                        If you're already got all your Employee's Previous Earnings in one place, fret not.
                        <br />
                        You can download a NIC Bands (or all Previous Earnings) template below, fill it in and upload it here. We'll do the rest.
                    </p>
                </div>
                <div className='col-xs-8 form-container'>
                    <div className="form-material">
                        <label className="css-input switch switch-sm switch-success">
                            <input
                                id="importAll"
                                name="importAll"
                                checked={importAll}
                                onClick={() => setImportAll(!importAll)}
                                onChange={(e) => { }} //To Prevent Error Spamming in Console
                                type="checkbox"
                            />
                            <span></span>
                            <label style={{ marginBottom: 0 }} htmlFor="hideSaved">
                                Include All Fields in Template
                            </label>
                        </label>
                    </div>
                </div>
                <div className='clearfix' />
                <button
                    type="button"
                    className="btn btn-default pull-left"
                    onClick={() => getPreviousEarningsTemplate(importAll)}
                >
                    <ArrowDownTrayIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
                    <div style={{ float: "left" }}>Excel Template</div>
                </button>

                <label for="uploadPreviousEarnings" className="btn btn-success pull-right" style={{ display: 'block' }}>
                    <ArrowUpTrayIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
                    <div style={{ float: "left" }}>Upload Previous Earnings</div>
                </label>
                <input style={{ display: 'none' }} id="uploadPreviousEarnings" type="file" accept='.xlsx' onChange={selectUploadFile} />


            </>)
            case 'Import': return (
                <>
                    <div className='col-xs-12'>
                        <p>
                            By importing this file, you acknowledge that any existing data can and will be replaced and/or amended.
                            To avoid any issues, please ensure that the data in the file is correct.
                            <br />
                            Any errors will be displayed below, and you will have the option to download a report of these errors.
                            <br />
                            <br />
                            Any changes made will be reflected in this employee's audit logs. Changes can only be reverted manually.
                        </p>
                    </div>
                    <div className='col-xs-8 form-container'>
                        <div className="form-material">
                            <label className="css-input switch switch-sm switch-success">
                                <input
                                    id="acknowledgement"
                                    name="acknowledgement"
                                    checked={acknowledgement}
                                    onClick={() => setAcknowledgement(!acknowledgement)}
                                    onChange={(e) => { }} //To Prevent Error Spamming in Console
                                    type="checkbox"
                                />
                                <span></span>
                                <label style={{ marginBottom: 0 }} htmlFor="hideSaved">
                                    I acknowledge the above
                                </label>
                            </label>
                        </div>
                    </div>
                    <div className="col-xs-12" style={{ marginTop: '2rem' }}>
                        {filesUploaded?.length > 0 ? <>
                            <button className="btn btn-success pull-right"
                                type="button"
                                disabled={!acknowledgement || uploading}
                                onClick={processUploadFile}
                            >
                                <ArrowUpTrayIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
                                <div style={{ float: "left" }}>{uploading ? "Importing..." : `Import ${file.name}`}</div>
                            </button>
                        </> : null}
                    </div>
                </>
            )
            case 'Review':
                return (
                    <>
                        <div className='col-xs-12 form-section'>
                            <div className='col-xs-4 section-header'>
                                <h1>Import Results</h1>
                            </div>
                            <div className='clearfix' />
                            {errors?.length > 0 ? <>
                                <div className='form-inner-section pr-0 pl-0'>
                                    <div
                                        style={{ display: "grid", gridGap: "1.5rem", grid: "1.5rem", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", padding: '1rem', borderBottom: 'solid rgb(244,244,244) 4px' }}>
                                        <div style={{ gridColumn: "span 1 / span 2", textAlign: 'center', opacity: '0.75' }}>
                                            <h5>Errors</h5>
                                        </div>
                                        <div style={{ gridColumn: "span 1 / span 2", textAlign: 'center', opacity: '0.75' }}>
                                            <h5>{saved ? '' : 'Not '}Saved</h5>
                                        </div>
                                    </div>
                                    {errors?.map((error, index) => {
                                        const isLast = (index + 1) === errors.length
                                        return <EarningsErrorsRow  {... { isLast, error, index }} />
                                    })}
                                </div>
                            </> : <>
                                <div className='form-inner-section'>
                                    <p>Previous Earnings imported successfully. You may now close this window</p>
                                </div>
                            </>}
                        </div>
                        <button className="btn btn-default pull-right" onClick={() => { closeModal(); setFile(null); }} style={{ marginBottom: 20 }}>Close</button>
                        {errors?.length > 0 ?
                            <CSVLink
                                filename="Earnings Import Errors.csv"
                                className="btn btn-default pull-left"
                                style={{ marginBottom: 20 }}
                                data={[
                                    ['Error'],
                                    ...errors?.map(item => [item])
                                ]}
                            >
                                <ArrowDownTrayIcon
                                    className='w-6 h-6 mr-3'
                                    style={{ verticalAlign: "text-bottom" }}
                                />
                                Download Error Report
                            </CSVLink>
                            : null}
                    </>
                )
        }
    }

    const selectUploadFile = (e) => {
        const file = e.target.files[0]; // accessing file
        // console.log('file', file);
        setFile(file); // storing file
        uploadFile(file);
    }

    const processUploadFile = () => {
        const options = {
            file,
        }

        uploadPreviousEarnings(options);
    }

    if (!modalStatus) return null

    return (
        <div className="modal" tabindex="-1" role="dialog" aria-hidden="true" style={{ display: "block", background: "rgba(0,0,0,0.4)", overflow: "scroll" }}>
            <div className="modal-dialog" style={{ width: importStage?.includes('Review') ? '75%' : '40%' }}>
                <div className="modal-content">
                    <div className="block block-themed block-transparent remove-margin-b" style={{ padding: 0 }}>
                        <div className="block-header bg-primary-dark" style={{ padding: 20 }}>
                            <ul className="block-options">
                                <li>
                                    <button type="button" onClick={() => { closeModal(); setFile(null) }}>
                                        <XMarkIcon className="h-6 w-6 mr-3 text-white" />
                                    </button>
                                </li>
                            </ul>
                            <h3 className="block-title">Import Previous Earnings</h3>
                        </div>
                        <div className="block-content" style={{ padding: 20 }}>
                            <ModuleStage />
                            <div className="clearfix" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    const {
        peImportModal,
        uploading,
        uploadResults,
    } = state.employee;

    const {
        filesUploading,
        filesUploaded,
    } = state.employees

    return {
        modalStatus: peImportModal,
        uploading,
        uploadResults,
        filesUploading,
        filesUploaded,
        jurisdiction: state.company?.settings?.jurisdiction
    }
}

const mapDispatchToProps = dispatch => ({
    closeModal: () => dispatch(EMPLOYEEACTIONS.togglePEImportModal()),
    getPreviousEarningsTemplate: (includeAllFields) => dispatch(EMPLOYEEACTIONS.getPreviousEarningsTemplate({ includeAllFields })),
    uploadPreviousEarnings: (input) => dispatch(EMPLOYEEACTIONS.uploadPreviousEarnings(input)),
    uploadFile: (file, agreement) => dispatch(EMPLOYEEACTIONS.uploadFile({ file, agreement })),
    employeesGetListWithSalary: () =>
        dispatch(
            EMPLOYEEACTIONS.employeesGetListWithSalary({
                from: format(addMonths(new Date(), -2), 'yyyy-MM-01'), // get list from last 2 months
                to: format(new Date(), 'yyyy-12-31'),
            })
        ),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ImportEmployeeModal)